import request from '@/utils/request'

// 链接分页
export function pageLink(data = {}) {
  return request({
    url: '/merchant-api/payment/link/pageLink',
    method: 'post',
    data
  })
}

// 更改链接状态
export function updateLinkStatus(data = {}) {
  return request({
    url: '/merchant-api/payment/link/updateLinkStatus',
    method: 'post',
    data
  })
}

// 创建链接
export function createLink(data = {}) {
  return request({
    url: '/merchant-api/payment/link/createLink',
    method: 'post',
    data
  })
}

// 链接详情
export function detailLink(params = {}) {
  return request({
    url: '/merchant-api/payment/link/detailLink',
    method: 'get',
    params
  })
}

// 产品分页
export function pageProduct(data = {}) {
  return request({
    url: '/merchant-api/payment/link/pageProduct',
    method: 'post',
    data
  })
}

// 添加产品
export function createProduct(data = {}) {
  return request({
    url: '/merchant-api/payment/link/createProduct',
    method: 'post',
    data
  })
}

// 更新产品
export function updateProduct(data = {}) {
  return request({
    url: '/merchant-api/payment/link/updateProduct',
    method: 'post',
    data
  })
}

// 删除产品
export function deleteProduct(params = {}) {
  return request({
    url: '/merchant-api/payment/link/deleteProduct',
    method: 'get',
    params
  })
}

// 获取链接QR图片(Base64)
export function getLinkQr(params = {}) {
  return request({
    url: '/merchant-api/payment/link/getLinkQr',
    method: 'get',
    params
  })
}

// 链接详情 > 链接交易
export function pageCheckout(data = {}) {
  return request({
    url: '/merchant-api/payment/link/pageCheckout',
    method: 'post',
    data
  })
}

// 链接详情 > 链接交易 > 详情
export function detailCheckout(params = {}) {
  return request({
    url: '/merchant-api/payment/link/detailCheckout',
    method: 'get',
    params
  })
}

// 编辑链接
export function updateLink(data = {}) {
  return request({
    url: '/merchant-api/payment/link/updateLink',
    method: 'post',
    data
  })
}

// 链接详情 > 报表下载
export function downloadCheckout(data = {}) {
  return request({
    url: '/merchant-api/payment/link/async/downloadCheckout',
    method: 'post',
    data
  })
}

// 子商户 payment links 传参需加上 sub_merchant_no
// 链接分页
export function mchPageLink(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/subPageLink',
    method: 'post',
    data
  })
}

// 更改链接状态
export function mchUpdateLinkStatus(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/updateSubLinkStatus',
    method: 'post',
    data
  })
}

// 创建链接
export function mchCreateLink(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/createSubLink',
    method: 'post',
    data
  })
}

// 链接详情
export function mchDetailLink(params = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/detailSubLink',
    method: 'get',
    params
  })
}

// 产品分页
export function mchPageProduct(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/pageSubProduct',
    method: 'post',
    data
  })
}

// 添加产品
export function mchCreateProduct(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/createProduct',
    method: 'post',
    data
  })
}

// 更新产品
export function mchUpdateProduct(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/updateSubProduct',
    method: 'post',
    data
  })
}

// 删除产品
export function mchDeleteProduct(params = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/deleteSubProduct',
    method: 'get',
    params
  })
}

// 获取链接QR图片(Base64)
export function mchGetLinkQr(params = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/getSubLinkQr',
    method: 'get',
    params
  })
}

// 链接详情 > 链接交易
export function mchPageCheckout(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/pageSubCheckout',
    method: 'post',
    data
  })
}

// 链接详情 > 链接交易 > 详情
export function mchDetailCheckout(params = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/detailSubCheckout',
    method: 'get',
    params
  })
}

// 编辑链接
export function mchUpdateLink(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/updateSubLink',
    method: 'post',
    data
  })
}

// 链接详情 > 报表下载
export function mchDownloadCheckout(data = {}) {
  return request({
    url: '/merchant-api/mch/merchantModel/async/downloadSubCheckout',
    method: 'post',
    data
  })
}
